module.exports = __webpack_public_path__ + "static/media/icon-device-test-ani.43b95d5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/icon-device-test-ani.png
// module id = 648
// module chunks = 1